(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klekpue_bogo_popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('klekpue-bogo-popup')) {
    customElements.define('klekpue-bogo-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.status = this.querySelector('[data-bogo-status]');
        this.buttons = [...this.querySelectorAll('[data-bogo-add]')];
        this.endAt = Date.parse(this.dataset.endAt || '');
        this.designMode = this.dataset.designMode === 'true';
        this.storageKey = `klekpue-bogo:${this.dataset.sectionId}:${this.dataset.endAt || 'open'}`;
        const signal = this.controller.signal;
        const listen = (element, event, handler) => element?.addEventListener(event, handler, { signal });

        listen(this.querySelector('[data-bogo-close]'), 'click', () => this.dialog.close());
        listen(this.dialog, 'cancel', () => this.rememberDismissal());
        listen(this.dialog, 'close', () => this.rememberDismissal());
        listen(this.dialog, 'click', event => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.buttons.forEach(button => listen(button, 'click', () => this.addOffer(button)));

        if (Number.isFinite(this.endAt)) {
          this.querySelector('[data-bogo-countdown]').hidden = false;
          this.updateCountdown();
          this.interval = window.setInterval(() => this.updateCountdown(), 1000);
        }

        const delay = this.designMode ? 250 : Math.max(0, Number(this.dataset.delay) || 5) * 1000;
        if (this.designMode || (!this.isDismissed() && !this.isExpired())) {
          this.openTimer = window.setTimeout(() => this.open(), delay);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        window.clearTimeout(this.openTimer);
        window.clearInterval(this.interval);
      }

      open() {
        if (!this.dialog?.open && !this.isExpired()) this.dialog.showModal();
      }

      isExpired() {
        return Number.isFinite(this.endAt) && Date.now() >= this.endAt;
      }

      isDismissed() {
        try {
          const dismissedAt = Number(localStorage.getItem(this.storageKey));
          const days = Math.max(1, Number(this.dataset.dismissDays) || 7);
          return dismissedAt > 0 && Date.now() - dismissedAt < days * 86400000;
        } catch {
          return false;
        }
      }

      rememberDismissal() {
        if (this.designMode) return;
        try {
          localStorage.setItem(this.storageKey, String(Date.now()));
        } catch {}
      }

      updateCountdown() {
        const remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          window.clearInterval(this.interval);
          if (this.dialog?.open) this.dialog.close();
          return;
        }
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor(totalSeconds % 86400 / 3600),
          minutes: Math.floor(totalSeconds % 3600 / 60),
          seconds: totalSeconds % 60
        };
        Object.entries(values).forEach(([name, value]) => {
          const output = this.querySelector(`[data-bogo-${name}]`);
          if (output) output.textContent = String(value).padStart(2, '0');
        });
      }

      async addOffer(button) {
        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;
        this.buttons.forEach(item => { item.disabled = true; });
        this.status.textContent = this.dataset.loadingText;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 2 }] })
          });
          if (!response.ok) throw new Error('cart/add');
          this.rememberDismissal();
          window.location.assign(`${root}cart`);
        } catch {
          this.status.textContent = this.dataset.errorText;
          this.buttons.forEach(item => { item.disabled = false; });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klekpue_brand_home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('klekpue-brand-home')) {
  customElements.define('klekpue-brand-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (el, event, fn) => el?.addEventListener(event, fn, { signal });
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const slides = [...gallery.querySelectorAll('[data-slide]')];
        const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
        let index = 0;
        const show = value => {
          index = (value + slides.length) % slides.length;
          slides.forEach((slide, n) => { slide.hidden = n !== index; });
          thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', String(n === index)));
          gallery.querySelector('[data-count]').textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
        };
        show(0);
        listen(gallery.querySelector('[data-prev]'), 'click', () => show(index - 1));
        listen(gallery.querySelector('[data-next]'), 'click', () => show(index + 1));
        thumbs.forEach((thumb, n) => listen(thumb, 'click', () => show(n)));
        listen(gallery, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
          thumbs[index].focus();
        });
      });
      this.video = this.querySelector('[data-kb-video]');
      const play = this.querySelector('.kb-play-overlay');
      if (this.video && play) {
        const loadVideo = () => {
          if (this.video.dataset.loaded === 'true') return;
          this.video.querySelectorAll('source[data-src]').forEach(source => {
            source.src = source.dataset.src;
          });
          this.video.dataset.loaded = 'true';
          this.video.controls = true;
          this.video.load();
        };
        listen(play, 'click', async () => {
          loadVideo();
          try { await this.video.play(); play.hidden = true; }
          catch { play.hidden = true; this.video.focus(); }
        });
        listen(this.video, 'play', () => { play.hidden = true; });
        listen(this.video, 'ended', () => { play.hidden = false; });
        listen(document, 'visibilitychange', () => { if (document.hidden) this.video.pause(); });
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.video?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
